export const rexTechTheme = {
  colors: {
    primary: {
      dark: '#0a5c36',    // Dark green
      main: '#1e8449',    // Medium green
      light: '#27ae60',   // Light green
      lighter: '#58d68d', // Very light green
      lightest: '#d4f4e3' // Pale green (updated for better contrast on white)
    },
    secondary: {
      dark: '#154360',
      main: '#1f618d',
      light: '#3498db'
    },
    neutral: {
      white: '#ffffff',
      lightGray: '#f8f9fa',
      gray: '#e9ecef',
      darkGray: '#6c757d',
      black: '#212529'
    },
    accent: {
      blue: '#2e86c1',
      orange: '#e67e22',
      yellow: '#f1c40f',
      teal: '#1abc9c'
    },
    background: {
      light: '#f8f9fa',
      dark: '#0a5c36'
    }
  },
  typography: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontSize: {
      xs: '12px',
      small: '14px',
      regular: '16px',
      large: '18px',
      xlarge: '24px',
      xxlarge: '32px',
      xxxlarge: '48px'
    },
    fontWeight: {
      light: 300,
      regular: 400,
      medium: 500,
      semiBold: 600,
      bold: 700
    }
  },
  spacing: {
    xs: '8px',
    sm: '12px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
    xxxl: '64px'
  },
  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '12px',
    xlarge: '16px',
    round: '50%'
  },
  shadows: {
    light: '0 2px 8px rgba(0, 0, 0, 0.08)',
    medium: '0 4px 16px rgba(0, 0, 0, 0.12)',
    heavy: '0 8px 24px rgba(0, 0, 0, 0.16)',
    button: '0 4px 12px rgba(30, 132, 73, 0.2)'
  },
  transitions: {
    default: 'all 0.3s ease',
    fast: 'all 0.15s ease',
    slow: 'all 0.5s ease'
  }
};